const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, `@cloudfour/components/sky-nav/sky-nav.twig`, new Map([[`class`, `t-dark`], [`menu`, new Map([[`items`, new Map([[0, new Map([[`link`, `/does`], [`title`, `What We Do`], [`current`, true]])], [1, new Map([[`link`, `/believes`], [`title`, `Our Approach`]])], [2, new Map([[`link`, `/made`], [`title`, `Our Work`]])], [3, new Map([[`link`, `/thinks`], [`title`, `Articles`]])], [4, new Map([[`link`, `/presents`], [`title`, `Speaking`]])], [5, new Map([[`link`, `/contributes`], [`title`, `Labs`]])], [6, new Map([[`link`, `/is`], [`title`, `Team`]])]])]])]]), false, false, 1));
                this.echo(this.include(context, this.source, this.loadTemplate(`6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, 37, 184), undefined, false, false, 37));
                this.echo(`
`);
                this.echo(this.include(context, this.source, this.loadTemplate(`6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, 57, 187), new Map([[`class`, `o-container--pad`]]), true, false, 57));
                this.echo(this.include(context, this.source, `@cloudfour/components/ground-nav/ground-nav.twig`, new Map([[`menu`, new Map([[`items`, new Map([[0, new Map([[`link`, `/does`], [`title`, `What We Do`], [`current`, true]])], [1, new Map([[`link`, `/believes`], [`title`, `Our Approach`]])], [2, new Map([[`link`, `/made`], [`title`, `Our Work`]])], [3, new Map([[`link`, `/thinks`], [`title`, `Articles`]])], [4, new Map([[`link`, `/presents`], [`title`, `Speaking`]])], [5, new Map([[`link`, `/contributes`], [`title`, `Labs`]])], [6, new Map([[`link`, `/is`], [`title`, `Team`]])], [7, new Map([[`link`, `/portland-device-lab`], [`title`, `Device Lab`]])], [8, new Map([[`link`, `https://cloudfour-patterns.netlify.app/`], [`title`, `Patterns`]])], [9, new Map([[`link`, `https://www.responsivefieldday.com/`], [`title`, `Responsive Field Day`]])]])]])], [`social`, new Map([[`items`, new Map([[0, new Map([[`link`, `https://twitter.com/cloudfour`], [`title`, `Follow us on Twitter`], [`icon`, `brands/twitter`]])], [1, new Map([[`link`, `https://github.com/cloudfour`], [`title`, `Find us on GitHub`], [`icon`, `brands/github`]])], [2, new Map([[`link`, `https://www.instagram.com/cloudfourpdx/`], [`title`, `Follow us on Instagram`], [`icon`, `brands/instagram`]])], [3, new Map([[`link`, `https://www.linkedin.com/company/cloud-four`], [`title`, `Follow us on LinkedIn`], [`icon`, `brands/linkedin`]])]])]])], [`action`, new Map([[`lead_in`, `Let’s discuss your project!`], [`title`, `Email us`], [`link`, `mailto:info@cloudfour.com`], [`icon`, `envelope`]])], [`organization`, new Map([[`name`, `Cloud Four, Inc.`], [`address`, new Map([[`street_address`, `510 SW 3rd Ave, Suite 420`], [`address_locality`, `Portland`], [`address_region`, `Oregon`], [`postal_code`, `97204`], [`address_country`, `USA`]])], [`email`, `info@cloudfour.com`], [`telephone`, `+1 (503) 290-1090`], [`url`, `https://cloudfour.com/`], [`founding_date`, `2007-12-13`]])]]), false, false, 82));
            }

            getTemplateName() {
                return `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, ``);
            }
        }],
        [184, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/cloud-cover/cloud-cover.twig`, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, 37);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/cloud-cover/cloud-cover.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, 39, 183), new Map([[`class`, `o-rhythm--condensed`]]), false, false, 39));
                this.echo(`  `);
            }

            getTemplateName() {
                return `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, ``);
            }
        }],
        [183, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, 39);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`,  -2], [`content`, `Our Team`]]), false, false, 43));
                this.echo(`        <p>
          We are a small, versatile team who care passionately about the web.
          We’re full of what our industry considers unicorns. Our designers
          code. Our developers went to art school.
        </p>
      `);
            }

            getTemplateName() {
                return `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, ``);
            }
        }],
        [187, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, 57);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, 60, 186), new Map([[`class`, `o-deck--2-column@s o-deck--4-column@l`], [`avatars`, (context.has(`avatars`) ? context.get(`avatars`) : null)]]), false, false, 60));
                this.echo(`  `);
            }

            getTemplateName() {
                return `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, ``);
            }
        }],
        [186, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/deck/deck.twig`, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, 60);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/deck/deck.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`avatars`) ? context.get(`avatars`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`avatar`] = __value__;
                    this.echo(`          `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, 66, 185), new Map([[`href`, `#`], [`avatar`, context.get(`avatar`)], [`class`, `c-card--circle-cover`]]), false, false, 66));
                    this.echo(`        `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('avatar');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`      `);
            }

            getTemplateName() {
                return `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, ``);
            }
        }],
        [185, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, 66);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['cover', [this, 'block_cover']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              `);
                this.echo(this.env.getFilter('escape').traceableCallable(68, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 68, this.source)(this.env, (context.has(`avatar`) ? context.get(`avatar`) : null), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`
            `);
            }

            block_cover(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              <img src="`);
                this.echo(this.env.getFilter('escape').traceableCallable(71, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 71, this.source)(this.env, (context.has(`avatar`) ? context.get(`avatar`) : null), `image`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`" alt="">
            `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              <p>`);
                this.echo(this.env.getFilter('escape').traceableCallable(74, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 74, this.source)(this.env, (context.has(`avatar`) ? context.get(`avatar`) : null), `role`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`</p>
            `);
            }

            getTemplateName() {
                return `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede');

let template = env.loadTemplate('6b88491c9bf4398bac8feb86eebd22fe816ce24b5b4c9d787a19e2748280dede');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/team/example/team-list.twig", args: context }
     );
     return rendered;;
};